import React, { FC, memo } from 'react'
import Heading from 'components/Common/Heading'
import PillTextBox, { PillColorTheme } from 'components/Common/PillTextBox'
import ToolFlyoutHeaderSidebar from './ToolFlyoutHeaderSidebar'
import { Tool, ToolSupportLevel } from '__generated__/api-types-and-hooks'
import { MEDIA_BUCKET } from 'config'
import ToolBookmark from '../ToolBookmark'

export interface IToolFlyoutMenuHeaderProps {
  toolDetail: Tool
}

const ToolFlyoutMenuHeader: FC<IToolFlyoutMenuHeaderProps> = ({ toolDetail }) => {
  console.log(toolDetail)
  return (
    <div className="xs:px-5 sm:px-0 pt-8">
      <div className="flex xs:flex-col lg:flex-row lg:justify-between">
        <div className="flex xs:flex-col sm:flex-row sm:items-start xs:gap-3 sm:gap-4 mdl:gap-10">
          <div>
            <img
              src={`${MEDIA_BUCKET}/${toolDetail.imageUrl}`}
              alt="quick book"
              className="xs:h-12 xs:w-12 sm:h-full sm:w-full"
            />
          </div>
          <div className="flex flex-col xs:gap-6 sm:gap-4">
            <div className="flex xs:flex-col sm:flex-row sm:items-center xs:gap-2 sm:gap-4 mdl:gap-10">
              <Heading
                variant="primary"
                tag="h2"
                className="xs:!text-xl mdl:!text-4xl !font-black text-primary-black tracking-[0.72px]"
              >
                {toolDetail.toolDisplayName}
              </Heading>
              {toolDetail.cyclrToolId && (
                <PillTextBox
                  colorTheme={
                    toolDetail.isConnected ? PillColorTheme.SUCCESS : PillColorTheme.ERROR
                  }
                  size="small"
                >
                  {!toolDetail.isConnected && 'Not '}Connected
                </PillTextBox>
              )}
              {toolDetail.supportLevel === ToolSupportLevel.Open && (
                <ToolBookmark tool={toolDetail} />
              )}
            </div>
            <p className="sm:max-w-[420px] md:max-w-[550px] mdl:max-w-[620px] lg:max-w-[660px] text-base font-medium text-primary-text">
              {toolDetail.description}
            </p>
          </div>
        </div>

        <ToolFlyoutHeaderSidebar toolDetail={toolDetail} />
      </div>
    </div>
  )
}

export default memo(ToolFlyoutMenuHeader)
